import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import bbox from '@turf/bbox';
import { featureCollection } from '@turf/helpers';
import unkinkPolygon from '@turf/unkink-polygon';
import { makeUnkinkable } from "../../../core/makeUnkinkable";
import { useMeQuery } from 'legoland-sdk/dist/experimental';
import chunk from 'lodash/chunk';
import { useContext, useState } from 'react';
import { Box, Button, Modal, useToasts } from 'tombac';
import { ProductModalHeader } from "../ProductModalHeader";
import { GeoLimitEditorContext, initLoadedGeoLimit } from "./GeoLimitEditor";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const GeoLimitImportExport = _ref => {
  let {
    limit,
    onChange,
    productId
  } = _ref;
  const {
    addToast
  } = useToasts();
  // const { email } = useUserDetails();
  const meQuery = useMeQuery();
  const email = meQuery.data?.me?.email;
  const {
    drawControl
  } = useContext(GeoLimitEditorContext);
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [loadedGeometry, setLoadedGeometry] = useState();
  const limitExists = limit?.features.length > 0;
  function handleImportClick() {
    openFileSelection();
  }
  function handleExportClick() {
    const blob = new Blob([JSON.stringify(limit, null, 2)], {
      type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = `geolimit-${email}-${productId}.geojson`;
    link.href = url;
    link.click();
  }
  function handleConfirmationClose() {
    setIsConfirmationOpen(false);
  }
  function openFileSelection() {
    const reader = new FileReader();
    reader.addEventListener('load', event => {
      handleImportResult(event.target.result);
    });
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/json,.json,.geojson';
    input.onchange = () => {
      if (input.files.length > 0) {
        setIsLoadingFile(true);
        reader.readAsText(input.files[0]);
      }
    };
    input.click();
  }
  function handleImportResult(result) {
    try {
      let geometry;
      try {
        geometry = unkinkPolygon(makeUnkinkable(result));
      } catch (error) {
        throw new SyntaxError(error);
      }
      geometry = initLoadedGeoLimit(geometry);
      if (limitExists) {
        setLoadedGeometry(geometry);
        setIsConfirmationOpen(true);
      } else {
        onChange(geometry);
        mapFitGeometry(geometry);
      }
    } catch (error) {
      if (error instanceof SyntaxError) {
        addToast('The file format is not a valid GeoJSON', 'danger', {
          content: error.message
        });
      } else {
        throw error;
      }
    }
    setIsLoadingFile(false);
  }
  function overwriteGeometry() {
    onChange(loadedGeometry);
    mapFitGeometry(loadedGeometry);
    setLoadedGeometry(undefined);
  }
  function mergeGeometry() {
    for (const feature of loadedGeometry.features) {
      const id = feature.id;
      let copyNum = 1;
      while (limit.features.find(lf => lf.id === feature.id)) {
        feature.id = `${id}-${copyNum}`;
        copyNum++;
      }
    }
    const geometry = initLoadedGeoLimit(featureCollection([...limit.features, ...loadedGeometry.features]));
    onChange(geometry);
    mapFitGeometry(geometry);
    setLoadedGeometry(undefined);
  }
  function mapFitGeometry(geometry) {
    drawControl.map.fitBounds(chunk(bbox(geometry), 2), {
      duration: 0,
      padding: 20
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Modal, {
      isOpen: isConfirmationOpen,
      onRequestClose: handleConfirmationClose,
      "data-sentry-element": "Modal",
      "data-sentry-source-file": "GeoLimitImportExport.tsx",
      "data-sentry-element": "Modal",
      children: [/*#__PURE__*/_jsx(ProductModalHeader, {
        onRequestClose: handleConfirmationClose,
        title: "Would you like to overwrite the existing limit?",
        "data-sentry-element": "ProductModalHeader",
        "data-sentry-source-file": "GeoLimitImportExport.tsx",
        "data-sentry-element": "ProductModalHeader"
      }), /*#__PURE__*/_jsxs(Box, {
        $display: "flex",
        $p: "2sp 4sp 3sp",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "GeoLimitImportExport.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Button, {
          $ml: "auto",
          onClick: () => {
            handleConfirmationClose();
            setLoadedGeometry(undefined);
          },
          type: "button",
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "GeoLimitImportExport.tsx",
          "data-sentry-element": "Button",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          disabled: !isConfirmationOpen,
          onClick: () => {
            handleConfirmationClose();
            mergeGeometry();
          },
          $ml: "1sp",
          type: "submit",
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "GeoLimitImportExport.tsx",
          "data-sentry-element": "Button",
          children: "Merge with the existing geometry"
        }), /*#__PURE__*/_jsx(Button, {
          disabled: !isConfirmationOpen,
          onClick: () => {
            handleConfirmationClose();
            overwriteGeometry();
          },
          $ml: "1sp",
          type: "submit",
          variant: "danger",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "GeoLimitImportExport.tsx",
          "data-sentry-element": "Button",
          children: "Yes, overwrite"
        })]
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      $alignItems: "center",
      $display: "flex",
      $gap: "1sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "GeoLimitImportExport.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(Button, {
        $flex: "1",
        busy: isLoadingFile,
        disabled: !drawControl,
        onClick: handleImportClick,
        size: "xs",
        type: "button",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "GeoLimitImportExport.tsx",
        "data-sentry-element": "Button",
        children: "Load GeoJSON"
      }), ' ', /*#__PURE__*/_jsx(Button, {
        $flex: "1",
        disabled: !limitExists,
        onClick: handleExportClick,
        size: "xs",
        type: "button",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "GeoLimitImportExport.tsx",
        "data-sentry-element": "Button",
        children: "Export limits"
      })]
    })]
  });
};